module.exports = __webpack_public_path__ + "static/media/as7tj823.36b8024f.png";